

const styles = (theme) => ({
  titleline: {
    textAlign: 'left',
    lineHeight: '50px',
  },
  title: {
    fontWeight: 'bold',
    display: 'inline',
  },
  bodyline: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    minHeight: '300px',
    minWidth: 'fit-content',
  },
  hiddenQuote: {
    visibility: 'hidden',
    height: 0,
    position: 'absolute',
  },
  displayingQuote: {
    visibility: 'unset',
  },
});

export const quoteTooltipStyles = (theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.swatch[200],
    color: theme.palette.common.swatch[700],
    fontSize: '.75rem',
    padding: '3px',
    margin: '.75rem',
    border: `1px solid ${theme.palette.common.swatch[400]}`,
    borderRadius: '2px',
    boxShadow: `0px 2px 4px #aaa`,
  },
});

export const toggleQuoteStyles = (theme) => ({
  root: {
    'backgroundColor': theme.palette.common.swatch[400],
    'marginTop': '1.5rem',
    'marginBottom': '.5rem',
    'borderRadius': '.65rem',
    'height': '.25rem',
    'width': '2.25rem',
    'padding': '.6rem',
    '&:hover': {
      backgroundColor: theme.palette.common.swatch[500],
    },
    '&:focus-visible': {
      backgroundColor: theme.palette.primary.swatch[300],
      color: theme.palette.primary.main,
      outline: `2px solid ${theme.palette.primary.swatch[700]}`,
    },
  },
});

export const pageContainerStyles = (theme) => ({
  root: {
    minWidth: 'min-content',
  },
});

export const headerContainer = (theme) => ({
  root: {
    position: 'relative',
    top: '22px',
    left: '-10px',
  },
});

export const headerContentStyles = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});

export const logoStyles = (theme) => ({
  root: {
    height: '48px',
    borderRadius: '8px',
    backgroundColor: '#2d8cff',
    flexShrink: 0,
    [theme.breakpoints.up('sm')]: {
      boxShadow: '0px 4px 20px 2px #eee',
      height: '60px',
      borderRadius: '12px',
    },
  },
});

export const envelopeStyles = (theme) => ({
  root: {
    backgroundColor: 'white',
    minWidth: 'fit-content',
    marginBottom: '5px',
    [theme.breakpoints.down('sm')]: {
      padding: '32px 16px',
      borderRadius: '4px',
      boxShadow: '0px 4px 20px 2px #eee',
    },
    [theme.breakpoints.up('sm')]: {
      boxShadow: '0px 4px 20px 2px #ddd',
      padding: '36px',
      borderRadius: '8px',
    },
  },
});

export const DownloadAllBtnStyles = (theme) => ({
  root: {
    background: 'none!important',
    border: 'none',
    padding: '0!important',
    textDecoration: 'underline',
    cursor: 'pointer',
    marginLeft: '10px',
    color: theme.palette.primary.dark,
  },
});

export default styles;
